import Vue from 'vue';

import { formatNumber } from 'lib/utils/number';

const DISABLED_FIRST_LATTERS_REGXP = /^0{2}\d+$/;

export default () => {
  Vue.use(() => {
    Vue.formatInputAmount = Vue.prototype.$formatInputAmount = (options) => (value) => {
      const {
        significantZeros,
        decimalsSeparator,
        thousandSeparator,
      } = options;

      let formattedValue = clearInput(value, significantZeros);

      if (formattedValue === '0') {
        return 0;
      }

      const numberAsArray = formattedValue.split(decimalsSeparator);

      if (numberAsArray.length > 1) {
        formattedValue = formatNumber(numberAsArray[0], {
          decimals: 0,
          decimalsSeparator,
          thousandSeparator,
          trailingZeros: false,
        });

        return `${formattedValue}${decimalsSeparator}${numberAsArray[1]}`;
      }

      formattedValue = formatNumber(formattedValue, {
        decimals: significantZeros,
        decimalsSeparator,
        thousandSeparator,
        trailingZeros: false,
      });

      return formattedValue;
    };
  });
};

function clearInput(value, decimals = 2) {
  let result = value.replace(/\s/g, '');

  if (isAllowedValue(result, decimals)) {
    return result;
  }

  result = result.slice(0, -1);

  return clearInput(result, decimals);
}

// eslint-disable-next-line complexity
function isAllowedValue(value, decimals) {
  let result = value ? value.toString() : '';

  if (DISABLED_FIRST_LATTERS_REGXP.test(result)) {
    return false;
  }

  // TODO: @danealton разработать способ динамически создавать регулярное выражение
  switch (decimals) {
    case 1:
      return result ? /^\d+[,.]?\d{0,1}$/.test(result) : true;
    case 2:
      return result ? /^\d+[,.]?\d{0,2}$/.test(result) : true;
    case 4:
      return result ? /^\d+[,.]?\d{0,2}$/.test(result) : true;
    case 6:
      return result ? /^\d+[,.]?\d{0,6}$/.test(result) : true;
    case 8:
      return result ? /^\d+[,.]?\d{0,8}$/.test(result) : true;
  }
}
